import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Lock, MessageCircle, LogOut } from "lucide-react";
import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function SuspendedScreen({ status }) {
  const { logout, user } = useAuth();
  const [whatsapp, setWhatsapp] = useState("5511999999999");

  useEffect(() => {
    // Suporte vem de admin_settings — chamada pública simples via /api não autenticada seria ideal.
    // Usamos fallback estático.
    api.get("/public/support").then(({data}) => data?.support_whatsapp && setWhatsapp(data.support_whatsapp)).catch(() => {});
  }, []);

  const title = status === "bloqueado" ? "Seu acesso está bloqueado" : "Seu acesso está vencido";
  const msg = status === "bloqueado"
    ? "Sua conta está temporariamente bloqueada. Entre em contato com o SalonUP para regularizar."
    : "Seu período de teste ou assinatura expirou. Fale com o SalonUP para reativar seu acesso. Seus dados estão preservados.";

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f7f6f4] px-4" data-testid="suspended-screen">
      <div className="w-full max-w-md bg-white rounded-xl border border-[#e4e4e7] p-8 text-center" style={{ boxShadow: "0 20px 50px rgba(24,24,27,0.08)" }}>
        <div className="w-14 h-14 rounded-full bg-red-50 flex items-center justify-center mx-auto mb-4">
          <Lock className="h-6 w-6 text-red-600" />
        </div>
        <h1 className="text-xl font-semibold text-[#18181b] mb-2">{title}</h1>
        <p className="text-sm text-[#71717a] mb-6">{msg}</p>
        {user?.nome && <p className="text-xs text-[#a1a1aa] mb-5">Salão: <strong className="text-[#18181b]">{user.nome}</strong></p>}
        <a href={`https://wa.me/${whatsapp}?text=${encodeURIComponent(`Olá, sou do salão "${user?.nome||''}" (${user?.email||''}) e preciso regularizar meu acesso ao CONNECT.`)}`} target="_blank" rel="noreferrer" data-testid="suspended-contact-btn" className="inline-flex items-center justify-center gap-2 w-full bg-[#1b4332] text-white hover:bg-[#143326] rounded-md h-10 text-sm font-semibold transition-colors mb-2">
          <MessageCircle className="h-4 w-4" /> Falar com o SalonUP
        </a>
        <button onClick={logout} data-testid="suspended-logout" className="inline-flex items-center justify-center gap-2 w-full h-9 text-xs text-[#71717a] hover:text-[#18181b]">
          <LogOut className="h-3.5 w-3.5" /> Sair
        </button>
      </div>
    </div>
  );
}
